import {
  ACTIVE_TEMPLATES_FETCH_API,
  ACTIVE_TEMPLATES_FETCH_API_FULFILLED,
  ACTIVE_TEMPLATES_FETCH_API_REJECTED,
  ACTIVE_TEMPLATES_FETCH_RECENTLY_USED,
  ACTIVE_TEMPLATES_FETCH_START,
  ACTIVE_TEMPLATES_SET_RECENTLY_USED,
  fetchRecentlyUsedTemplatesAction,
  TEMPLATE_ADD_TO_RECENTLY_USED
} from './templates-actions';
import {TEMPLATES_FILTER_PROPERTIES, TEMPLATES_SORT_PROPERTIES} from '../../constants/issue-query-params';
import {showNotificationAction} from '../actions';
import {NotificationLevels, NotificationTypes} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import i18n from '../../utils/i18n';
import {getCurrentProject, getRecentlyUsedTemplateIds} from '../selectors';
import {getLocalStorageByKey} from '../../utils/localStorage-helpers';
import {
  RECENTLY_USED_TEMPLATE_LOCAL_STORAGE_PREFIX,
  RECENTLY_USED_TEMPLATES_SIZE
} from '../../constants/issue-templates';
import take from 'lodash/take';
import uniq from 'lodash/uniq';

export default issuesV2Api => store => next => action => {
  switch (action.type) {
    case ACTIVE_TEMPLATES_FETCH_START:
      store.dispatch({
        type: ACTIVE_TEMPLATES_FETCH_API,
        payload: issuesV2Api.getIssueTemplates({
          limit: 9999,
          sort: `${TEMPLATES_SORT_PROPERTIES.CATEGORY},${TEMPLATES_SORT_PROPERTIES.TITLE}`,
          [TEMPLATES_FILTER_PROPERTIES.IS_ACTIVE]: true
        })
      });
      break;
    case ACTIVE_TEMPLATES_FETCH_API_FULFILLED:
      store.dispatch(fetchRecentlyUsedTemplatesAction());
      break;
    case ACTIVE_TEMPLATES_FETCH_API_REJECTED:
      store.dispatch(
        showNotificationAction({
          type: NotificationTypes.TOAST,
          level: NotificationLevels.ERROR,
          message: i18n.t('createFromTemplate.errors.fetchFailed')
        })
      );
      break;
    case ACTIVE_TEMPLATES_FETCH_RECENTLY_USED: {
      const state = store.getState();
      const projectId = getCurrentProject(state).id;
      const recentlyUsedTemplates =
        getLocalStorageByKey(`${RECENTLY_USED_TEMPLATE_LOCAL_STORAGE_PREFIX}_${projectId}`) || [];
      store.dispatch({
        type: ACTIVE_TEMPLATES_SET_RECENTLY_USED,
        payload: recentlyUsedTemplates
      });
      break;
    }
    case TEMPLATE_ADD_TO_RECENTLY_USED: {
      const state = store.getState();
      const projectId = getCurrentProject(state).id;
      const recentlyUsedTemplates = getRecentlyUsedTemplateIds(state);
      const updatedRecentlyUsedTemplates = take(
        uniq([action.payload, ...recentlyUsedTemplates]),
        RECENTLY_USED_TEMPLATES_SIZE
      );
      localStorage.setItem(
        `${RECENTLY_USED_TEMPLATE_LOCAL_STORAGE_PREFIX}_${projectId}`,
        JSON.stringify(updatedRecentlyUsedTemplates)
      );
      store.dispatch({
        type: ACTIVE_TEMPLATES_SET_RECENTLY_USED,
        payload: updatedRecentlyUsedTemplates
      });
      break;
    }
    default:
      break;
  }
  next(action);
};
